import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const otpVerificationStatusRemoteBankingContacts = createAsyncThunk<
  null,
  { applicationId: string; verificationStatus: string; token: string; personId: number }
>(
  'otp/otpVerificationStatusRemoteBankingContacts',
  async ({ applicationId, verificationStatus, personId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
      const response = await api.patch(
        `/remote-banking-contacts/applications/${applicationId}/persons/${personId}/verification-status`,
        { verificationStatus },
        { headers }
      );
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const otpVerificationCheckRemoteBankingContacts = createAsyncThunk<
  null,
  { applicationId: string | number; token: string }
>(
  'otp/otpVerificationCheckRemoteBankingContacts',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
      const response = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/persons/verification/check`,
        null,
        { headers }
      );
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
